var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "services-portfolio_svgrepo.com",
    clipPath: "url(#clip0_988_310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.431 12.3673H29.4809V11.1765C29.4809 10.1937 28.6759 9.39029 27.6946 9.39029H19.8321V8.3503C19.8321 6.87051 18.6286 5.67175 17.1536 5.67175H12.5808C11.8663 5.67175 11.1948 5.95116 10.6867 6.45927C10.1785 6.96738 9.90068 7.63418 9.90068 8.3503V9.39183H2.03817C1.05537 9.39029 0.251953 10.1936 0.251953 11.1765V27.1287L6.25686 14.9633C6.98564 13.4819 8.78296 12.3673 10.431 12.3673ZM11.687 8.3503C11.687 8.11373 11.7838 7.88982 11.9506 7.72155C12.1173 7.55005 12.3427 7.45642 12.5793 7.45642H17.152C17.6459 7.45642 18.0444 7.85655 18.0444 8.3503V9.39183H11.687V8.3503H11.687Z",
    fill: "#E0B959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.0888 14.1504H10.4307C9.44942 14.1504 8.28879 14.8712 7.85849 15.7508L0.95816 29.7294C0.523145 30.6074 0.97244 31.3283 1.95369 31.3283H27.6118C28.593 31.3283 29.7553 30.609 30.1871 29.7294L37.0859 15.7508C37.5193 14.8712 37.0732 14.1504 36.0888 14.1504Z",
    fill: "#E0B959"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(0.251953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/ServicesIcon.3f3ba2b7fe4f354bb365dbf0a2d6fba2.svg";
export { ForwardRef as ReactComponent };